import axios from 'axios'
import {sessionData} from './stores.js'

const gapi_url = process.env.BASE_GAMBIT_URL

async function makeOrder(amount) {
  let session
  const unsub = sessionData.subscribe (s => session = s)
  let tok = await session.user.getIdToken()
  const response = await axios.post(
    gapi_url + 'payments/order'
    , { depAmount: Number(amount) }
    , { headers: {'Authorization': `Bearer ${tok}`} }
  );
  unsub()
  return(response.data)
}

async function skrillPrepare(amount) {
  let session
  const unsub = sessionData.subscribe (s => session = s)
  let idToken = await session.user.getIdToken()
  const response = await axios.post(
    gapi_url + 'skrill/prepare'
    , { prepareAmount: Number(amount)
      , prepareCurrency: "USD" }
    , { headers: { 'Authorization': `Bearer ${idToken}` } }
  );
  unsub()
  return(response.data)
}

export {makeOrder, skrillPrepare}
